<template>
  <ValidationObserver v-slot="ob" tag="div" ref="observer">
    <form novalidate class="form" @submit.prevent="ob.handleSubmit(submit)">
      <div class="form__alert"></div>

      <div class="form__body">
        <slot></slot>
      </div>

      <div class="form__footer" v-if="$slots.footer && $slots.footer.length">
        <slot name="footer"></slot>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import { ValidationObserver } from 'vee-validate'

export default {
  name: 'FormSection',

  components: {
    ValidationObserver,
  },

  mounted() {
    this.unwatchValidation = this.$watch(
      '$refs.observer.flags.valid',
      valid => {
        this.$store.commit('podcast/setValid', valid)
      },
      {
        immediate: true,
      },
    )
  },

  beforeDestroy() {
    this.$unwatchValidation && this.$unwatchValidation()
  },

  methods: {
    submit() {
      this.$emit('submit')
    },
  },
}
</script>
